export default {
  executeAction (vue, name, args) {
    try {
      this.actions[name](vue, args)
    } catch (err) {
      vue.$actions[name](args)
    }
  },
  async action (vue, actionObj) {
    if (Array.isArray(actionObj.actions)) {
      for (let action of actionObj.actions) {
        await this.executeAction(vue, action.name, action.args)
      }
    } else if (typeof actionObj.action === 'string') {
      this.executeAction(vue, actionObj.action, actionObj.args)
    }
  },
  actions: {
    async open (vue, args) {
      if (args.target == null) {
        args.target = '_self'
      }
      if (args.target === '_self') {
        await vue.$store.dispatch('chatState', false)
        await vue.$store.dispatch('bubbleMessageAfterClose')
      }
      window.open(args.url, args.target)
    },
    closeChat (vue) {
      vue.$store.dispatch('chatState', false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/generalActions/generalActions.js